Vendd.Scripts.load(function () {

    Vendd.MessageBus.subscribe(Vendd.Widget.Messages.BindControl, 'x-product-box', function (envelope) {

        var $context = envelope.message.data.context, model, quickBuyObj, $hoveredProduct, selectedSku, colorSelectorCallback = false,
            $boxes = $('.x-product-box', $context);

        if ($boxes.length < 1)
            return;

        $boxes.on('click', '.js-remove-from-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this), $box, productId;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');

            productId = $box.prop('data-productid');

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.ProductCompare.Messages.Remove(productId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-add-to-compare', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this),
                $box, $qty,
                id, skuId, path, qty;

            if ($this.closest('.compare-button').hasClass('x-disabled'))
                return;

            $box = $this.closest('.x-product-box');
            $qty = $('.js-qty', $box);

            id = $box.data('productid');
            skuId = $box.data('variantid');
            path = $box.data('path');
            qty = ($qty.val() ? stringToNumber($qty.val()) : null) || 1;

            Vendd.MessageBus.publishAsync($box.get(0), new Vendd.ProductCompare.Messages.Add(id, skuId));

            if ($('.x-productcompare-widget').data('template') === 1) {
                Vendd.MessageBus.publishAsync($box.get(0), new Vendd.Widget.Messages.OpenWidget(Vendd.Widget.ProductCompareWidget, false));
            }
        });

        $boxes.on('click', '.js-request-info', function (e) {
            e.preventDefault();
            e.stopPropagation();

            var $this = $(this);

            var isUsed = $this.closest('.x-product-box').data('is-used').toLowerCase() === 'true';

            var itemId = $this.closest('.x-product-box').data('productid');
            var modelId = $this.closest('.x-product-box').data('model-id');
            var modelName = $this.closest('.x-product-box').data('model-name');

            $('#request-info-form').attr('data-item-id', itemId);
            $('#request-info-form').attr('data-model-id', modelId);
            $('#request-info-form').attr('data-model-name', modelName);
            $('#request-info-form').attr('data-is-used', isUsed);

            $.fancybox.open({
                src: '#request-info-form',
                type: 'inline',
                touch: false,
                autoFocus: false,
                opts: {
                    afterClose: function (instance, current) {
                        //re-initialize form
                        $('#request-info-form').get(0).initialize();
                    }
                }
            });       
        });
    });

    Vendd.MessageBus.subscribe(Vendd.ProductCompare.Messages.GetWidgetModelSuccess, 'x-product-box', function (envelope) {
        var data = envelope.message.data.model.Items;
        var $boxes = $('.x-product-box');

        if ($boxes.length < 1)
            return;

        $boxes.each(function (i, el) {
            var $el = $(el);
            var id = $el.data('productid');

            if (data) {
                var productInCompare = data.find(function (x) { return id === x.Id });
                var $compareButton = $('.compare-button', $el);

                if (productInCompare) {
                    $el.prop('data-productid', productInCompare.Id);
                    $compareButton.addClass('already-in-compare');
                    $('.js-add-to-compare', $compareButton).addClass('disabled');
                    $('.js-remove-from-compare', $compareButton).removeClass('disabled');
                } else {
                    $compareButton.removeClass('already-in-compare');
                    $('.js-add-to-compare', $compareButton).removeClass('disabled');
                    $('.js-remove-from-compare', $compareButton).addClass('disabled');
                }
            }

        });

    });

});

//function used in productBox_A.js and productList_A.js
function addSkuParameterInProductBox($productBox, selectedColorId, state) {

    if ($productBox.length < 1) return;

    var productBox = $productBox.get(0);

    //get product box data
    var productId = $productBox.data('productid');
    var variantId = $productBox.data('variantid');
    var defaultColor = $productBox.data('default-colorid');
    var $link = $productBox.data('url');
    var query = ($link.indexOf('?') > -1) ? '&' : '?';

    var $selectedSkuLink;

    if (defaultColor === selectedColorId) {
        //add data attribute
        $productBox.attr('data-selected-sku', variantId);
        //add sku parameter in product box links
        $selectedSkuLink = $link + (($link.indexOf('skuid=') === -1) ? query + 'skuid=' + variantId : '');
        $('.js-product-link', $productBox).attr('href', $selectedSkuLink);
    } else {
        //get quickbuy model
        var state = state ? state : Vendd.Quickbuy.initState(productId, defaultColor);
        if (!state) return;

        //find first available size of selected color
        var selectedColorModel = state.Colors.find(function (x) { return x.Id === selectedColorId });
        var defaultSizeId = selectedColorModel ? selectedColorModel.AvailableSizes[0] : null;

        //get selected sku of selected color
        productBox.model = state;
        var selectedSku = Vendd.Quickbuy.GetSkuData(productBox, productId, defaultColor, selectedColorId, defaultSizeId);
        if (selectedSku !== null && typeof selectedSku !== 'undefined') {
            //add data attribute
            $productBox.attr('data-selected-sku', selectedSku.SkuData.SkuId);
            //add sku parameter in product box links
            $selectedSkuLink = $link + (($link.indexOf('skuid=') === -1) ? query + 'skuid=' + selectedSku.SkuData.SkuId : '');
            $('.js-product-link', $productBox).attr('href', $selectedSkuLink);
        }
    }
}